/**
 * 共用数据模块接口列表api
 */

import base from "./base/index"; // 接口域名列表 // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import qs from "qs"; // 按需导入qs模块:post请求用到

const beadmin = {
  /**
   * 根据等级统计告警
   * @param {*} startTime
   * @param {*} endTime
   */
  getEventStatisticsNumByLevel(startTime, endTime) {
    let params = {
      startTime:
        typeof startTime == "string" ? startTime.replace(/-/g, "/") : startTime,
      endTime:
        typeof endTime == "string" ? endTime.replace(/-/g, "/") : endTime,
    };
    return axios.post(
      base.beadmin.getEventStatisticsNumByLevel,
      qs.stringify(params)
    );
  },
  /**
   * 根据告警类型统计告警
   * @param {*} startTime
   * @param {*} endTime
   */
  getEventStatisticsNumByCode(startTime, endTime, limit) {
    let params = {
      startTime:
        typeof startTime == "string" ? startTime.replace(/-/g, "/") : startTime,
      endTime:
        typeof endTime == "string" ? endTime.replace(/-/g, "/") : endTime,
      limit: limit,
    };
    return axios.post(
      base.beadmin.getEventStatisticsNumByCode,
      qs.stringify(params)
    );
  },
  getEnergyEfficiencyBenchmark(
    meterId,
    timeType,
    startTime,
    endTime,
    areaSize
  ) {
    let params = {
      meterId: meterId,
      timeType: timeType,
      startTime:
        typeof startTime == "string"
          ? startTime.replace(/-/g, "/")
          : startTime.replace(/-/g, "/"),
      endTime:
        typeof endTime == "string"
          ? endTime.replace(/-/g, "/")
          : endTime.replace(/-/g, "/"),
      areaSize: areaSize,
    };
    return axios.get(base.beadmin.getEnergyEfficiencyBenchmark, {
      params: params,
    });
  },
  /**
   * 获取用能体检报告
   */
  peekReport(id) {
    let params = {
      id: id,
    };
    return axios.post(base.beadmin.peekReport, qs.stringify(params));
  },
  /**
   * 获取成本费用
   */
  getExpensesOfUse(viewId, timeType, startTime, measureId) {
    let params = {
      viewId: viewId,
      timeType: timeType,
      startTime:
        typeof startTime == "string" ? startTime.replace(/-/g, "/") : startTime,
      measureId: measureId,
    };
    return axios.post(base.beadmin.getExpensesOfUse, qs.stringify(params));
  },
  /**
   * 能效对标本地、行业对标值
   * @param {*} measureId
   * @param {*} timeType
   * @param {*} startTime
   * @param {*} endTime
   */
  getBenchmarkKPI(measureId, timeType, startTime, endTime) {
    let params = {
      measureId: measureId,
      timeType: timeType,
      startTime:
        typeof startTime == "string"
          ? startTime.replace(/-/g, "/")
          : startTime.replace(/-/g, "/"),
      endTime:
        typeof endTime == "string"
          ? endTime.replace(/-/g, "/")
          : endTime.replace(/-/g, "/"),
    };
    return axios.post(base.beadmin.getBenchmarkKPI, qs.stringify(params));
  },
};

export default beadmin;
